/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  primaryColors,
  transparentColors
} from '@assets/styles/helpers/colors.styles'

export const switchStyles = {
  width: 38,
  height: 22,
  padding: 0,
  pointerEvents: 'auto',
  '& .MuiSwitch-switchBase': {
    padding: '2px',
    margin: 0,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: primaryColors.orange,
        opacity: 1,
        border: 0
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff'
    }
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 18,
    height: 18,
    backgroundColor: primaryColors.white
  },
  '& .MuiSwitch-track': {
    borderRadius: 16,
    backgroundColor: transparentColors.whiteShade3,
    opacity: 1,
    transition: (theme: any) =>
      theme.transitions.create(['background-color'], {
        duration: 400
      })
  }
}
